module.exports = __webpack_public_path__ + "img/28_87.624bd602.png";